/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


  // Handle direct links in duplicate selector
  document.addEventListener('click', function(event) {
    const link = event.target.closest('.duplicate-selector .combo-box__option-item[href]');
    if (link) {
      // Let the link work normally (no preventDefault)
      return;
    }
  });
  
  // Sync duplicate selector when main variant changes
  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;
    if (variant) {
      // Update the duplicate selector display
      const duplicateSelector = document.querySelector('.duplicate-selector');
      if (duplicateSelector) {
        const displayText = duplicateSelector.querySelector('.select__selected-value');
        const optionPosition = duplicateSelector.getAttribute('data-option-position');
        
        if (displayText && optionPosition) {
          // Get the correct option value based on position
          const optionValue = variant['option' + optionPosition];
          if (optionValue) {
            displayText.textContent = optionValue;
          }
        }
      }
    }
  });






// レビューアプリ
// Fix Judge.me review modal white screen issue  
document.addEventListener('DOMContentLoaded', function() {
  console.log('Judge.me review modal fix loaded');
  
  // Simple function to reload page when modal is closed
  function reloadPageOnModalClose() {
    console.log('Judge.me modal closed, reloading page to reset state');
    // setTimeout(() => {
    //   window.location.reload();
    // }, 200);
  }
  
  // Fix close button visibility and add click handler
  function ensureCloseButtonWorks() {
    const closeButtons = document.querySelectorAll('.jdgm-write-review-modal__close-btn');
    closeButtons.forEach(button => {
      // Make sure the button is visible and clickable
      button.style.opacity = '1';
      button.style.visibility = 'visible';
      button.style.pointerEvents = 'auto';
      button.style.display = 'block';
      
      // Add direct click handler to ensure it works
      button.addEventListener('click', function(event) {
        console.log('Close button clicked directly');
        event.preventDefault();
        event.stopPropagation();
        reloadPageOnModalClose();
      });
    });
  }
  
  // Listen for modal close events and reload page
  document.addEventListener('click', function(event) {
    // Handle close button clicks to reload page
    const closeButton = event.target.closest('.jdgm-write-review-modal__close-btn, .jdgm-write-review-modal__nav-btn-close');
    if (closeButton) {
      console.log('Review modal close button clicked');
      event.preventDefault();
      event.stopPropagation();
      reloadPageOnModalClose();
    }
  });
  
  // Watch for modal being added to DOM and fix close button
  const modalObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check for newly added modal elements
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            const modal = node.querySelector && node.querySelector('.jdgm-write-review-modal');
            if (modal || node.classList && node.classList.contains('jdgm-write-review-modal')) {
              console.log('Judge.me modal added to DOM, ensuring close button works');
              setTimeout(ensureCloseButtonWorks, 100);
            }
          }
        });
      }
      
      // Also check for style changes (modal being hidden)
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const modal = mutation.target.closest('.jdgm-write-review-modal');
        if (modal && mutation.target.style.display === 'none') {
          console.log('Judge.me modal hidden, reloading page');
          reloadPageOnModalClose();
        }
      }
    });
  });
  
  // Start observing the document for modal visibility changes
  modalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });
  
  // Watch for ESC key press to close modal
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const modal = document.querySelector('.jdgm-write-review-modal');
      if (modal && modal.style.display !== 'none') {
        console.log('ESC key pressed while modal open, will reload page');
        setTimeout(reloadPageOnModalClose, 300);
      }
    }
  });
  
  // Initial check for existing modal and fix close button
  setTimeout(() => {
    const existingModal = document.querySelector('.jdgm-write-review-modal');
    if (existingModal) {
      console.log('Found existing Judge.me modal, fixing close button');
      ensureCloseButtonWorks();
    }
  }, 1000);
  
  // Also run after delays to catch late-loading elements
  setTimeout(ensureCloseButtonWorks, 2000);
  setTimeout(ensureCloseButtonWorks, 3000);
});




// お気に入りリストボタン非表示


// 商品一覧（Globo）のフィルム・ガラスの仕様タグ（snippets/globo.filter.product.liquid）
// タグを押すとカードの画像・価格・リンクがその仕様のバリエーションになる（機種などほかのオプションは今の選択のまま）
document.addEventListener('click', function (event) {
  const tag = event.target.closest('.spec-tag');
  if (!tag) return;

  const card = tag.closest('.spf-product-card');
  const select = card && card.querySelector('.spf-product__variants');
  if (!select) return;

  const optionIndex = tag.dataset.option;
  const variants = Array.from(select.options);
  const current = select.options[select.selectedIndex] || variants[0];
  const candidates = variants.filter((variant) => variant.dataset['option' + optionIndex] === tag.dataset.optionValue);
  if (candidates.length === 0) return;

  // ほかのオプションが一致するもの > 在庫ありの順で選ぶ
  const score = (variant) => {
    let matches = 0;
    [1, 2, 3].forEach((index) => {
      if (String(index) !== optionIndex && variant.dataset['option' + index] === current.dataset['option' + index]) matches++;
    });
    return matches * 2 + (variant.dataset.available === 'true' ? 1 : 0);
  };
  const variant = candidates.reduce((best, candidate) => (score(candidate) > score(best) ? candidate : best));

  select.value = variant.value;

  card.querySelectorAll('.spec-tag').forEach((item) => {
    item.classList.toggle('is-selected', item === tag);
    item.setAttribute('aria-pressed', item === tag ? 'true' : 'false');
  });

  // 商品ページへ選択したバリエーションのまま遷移させる
  card.querySelectorAll('a.spf-product-card__image-wrapper, .spf-product-card__title a').forEach((link) => {
    const url = new URL(link.href, window.location.href);
    url.searchParams.set('variant', variant.value);
    link.href = url.toString();
  });

  // バリエーションの画像を表示（今の画像と表示状態を入れ替える）
  const image = Array.from(card.querySelectorAll('.spf-product-card__image')).find((img) => (img.dataset.variants || '').split(',').indexOf(variant.value) !== -1);
  const mainImage = card.querySelector('.spf-product-card__image-main');
  if (image && mainImage && image !== mainImage) {
    const imageState = ['secondary', 'hidden'].find((state) => image.classList.contains('spf-product-card__image-' + state)) || 'hidden';
    image.classList.remove('spf-product-card__image-' + imageState);
    image.classList.add('spf-product-card__image-main');
    mainImage.classList.remove('spf-product-card__image-main');
    mainImage.classList.add('spf-product-card__image-' + imageState);
  }

  // 価格（セール表示の場合はそのまま）
  const priceNumber = card.querySelector('.spf-product-card__price .price-number');
  const priceSuffix = card.querySelector('.spf-product-card__price .price-suffix');
  if (priceNumber && variant.dataset.price) {
    priceNumber.textContent = Number(variant.dataset.price).toLocaleString('ja-JP');
    if (priceSuffix) priceSuffix.textContent = '円(税込)';
  }
});

// 仕様タグの横スクロール：はみ出している側にフェードと矢印を表示し、矢印を押すとその方向へスクロールする
(function () {
  const updateSpecTags = (scroller) => {
    const wrapper = scroller.parentElement;
    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    wrapper.classList.toggle('has-prev', scroller.scrollLeft > 1);
    wrapper.classList.toggle('has-next', scroller.scrollLeft < maxScroll - 1);
  };
  const updateAllSpecTags = () => document.querySelectorAll('.spec-tags__scroll').forEach(updateSpecTags);

  // scroll はバブリングしないためキャプチャで受け取る
  document.addEventListener('scroll', (event) => {
    if (event.target.classList && event.target.classList.contains('spec-tags__scroll')) updateSpecTags(event.target);
  }, true);

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('.spec-tags__arrow');
    if (!arrow) return;
    const scroller = arrow.parentElement.querySelector('.spec-tags__scroll');
    const direction = arrow.classList.contains('spec-tags__arrow--prev') ? -1 : 1;
    scroller.scrollBy({ left: direction * scroller.clientWidth * 0.6, behavior: 'smooth' });
  });

  // Globo はカードを後から描画するため、描画完了時にも判定する
  window.addEventListener('globoFilterRenderCompleted', () => requestAnimationFrame(updateAllSpecTags));
  window.addEventListener('resize', updateAllSpecTags);
  window.addEventListener('load', updateAllSpecTags);
  if (document.fonts) document.fonts.ready.then(updateAllSpecTags);
})();
